/*
 * Copyright (c) 2020. Jellybean B.V. Apeldoorn
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

/*
    Module voor localconfig
 */

import {APP_INITIALIZER, NgModule} from "@angular/core";
import {localConfig} from "./localconfig";
import {HttpClientModule} from "@angular/common/http";
import moment from 'moment';
// const moment = (momentns.default || momentns) as (input?: any, format?: string, strict?: boolean) => moment.Moment;

/**
 * APP_INITIALIZER functie voor het laden van de config
 * @param config
 */
export function initConfig(config: localConfig)
{
    console.log(`SihW-ng library (c) 2019-${moment().year()} Jellybean B.V., Apeldoorn, The Netherlands.`);
    return function() {return config.init()};
    // return () => config.init();
}

@NgModule({
    declarations: [],
    imports: [
        HttpClientModule
    ],
    providers: [
        localConfig,
        { provide: APP_INITIALIZER, useFactory: initConfig, deps: [localConfig], multi:true}
    ]
}) export class LocalconfigModule{}
